<template>
  <span class="regular-12 text-black text-center">
    {{ modelValue }}
    <button class="btn btn-secondary btn-sm" v-on:click="showCatalog = true">
      <BaseIcon name="book" />
    </button>
  </span>
  <ProductManufacturingOperationsModal
    v-model:show="showCatalog"
    :operation="id"
  />
</template>

<script>
import BaseIcon from "../../icons/BaseIcon";
import ProductManufacturingOperationsModal from "../../modals/ProductManufacturingOperationsModal";
export default {
  name: "ProductManufacturingOperations",
  components: { ProductManufacturingOperationsModal, BaseIcon },
  props: {
    id: Number,
    type: String,
    row: Object,
    modelValue: Object,
  },
  data() {
    return {
      showCatalog: false,
      value: this.modelValue,
    };
  },
  watch: {
    value() {
      this.$emit("update:modelValue", this.value);
      this.$emit("change");
    },
    modelValue() {
      this.value = this.modelValue;
    },
  },
  methods: {},
  emits: ["update:modelValue", "change"],
};
</script>
